// extracted by mini-css-extract-plugin
export var typingIndicator = "_qm-0";